import * as React from 'react';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { useLocation, useHistory } from 'react-router-dom';

// COMPONENTS
import LoginModal from '../../pages/Login/LoginModal';

// TYPES
interface AttachmentType {}

export const Attachment: React.FC<AttachmentType> = ({}) => {
	const history = useHistory();

	// Check if User is Logged in
	const loggedIn = useAppSelector((state) => state.user.loggedIn);

	// Get Id from search Param
	const { search } = useLocation();
	const Id = new URLSearchParams(search).get('Id');

	// Build Redirect Url based on if User is logged in or not
	const loggedInRedirectUrl = `/api/incident/asset?Id=${Id}`;

	const notLoggedInRedirectUrl = `/attachment/api/incident/asset?Id=${Id}`;

	if (loggedIn) {
		window.location.href = loggedInRedirectUrl;

		history.push('/dashboard');
	}

	return <LoginModal returnUrl={notLoggedInRedirectUrl} />;
};

export default Attachment;
